import { getPath, getInitialState } from "../../utils";

const initialState = {
  stateList: [],
  prevPage: -1,
  nextpage: -1,
  activeState: {},
  activeFilters: {},
  currentPage: 1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_STATE_LIST":
      return setStateList(state, action);
    case "SET_ACTIVE_STATE":
      return setActiveState(state, action);
    case "SET_ACTIVE_STATE_FILTERS":
      return setActiveStateFilters(state, action);
    case "RESET_STATE_STATE":
      return resetState(state, action);
    case "SET_CURRENT_PAGE_STATE":
      return setCurrentPageState(state, action);
    default:
      return state;
  }
}

const setStateList = (state, action) => {
  return {
    ...state,
    stateList: getPath(action.payload, "states", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const setActiveState = (state, action) => {
  return {
    ...state,
    activeState: action.payload,
  };
};

const setActiveStateFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setCurrentPageState = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};
